@if (show) {
  <header class="summary header-fixed summary-static"
    [ngClass]="{ 'sb-bg-dark' : !isTransparent }"
    >
    <div class="summary__body"
      [ngClass]="{'text-light' : !isTransparent}">
      @if ((showAction || backText) && !isMobileApp) {
        <div class="summary__actions sub-menu-extra"
          >
          <sb-button buttonClass="secondary"
            customClasses="p-small"
            (onClick)="back()"
            [ngClass]="{'invisible' : !showBack}"
            [message]="backText"
          iconName="back"></sb-button>
          @if (showAction) {
            <sb-button [buttonClass]="actionButtonClass"
              (onClick)="action()"
              [message]="actionText"
              [iconName]="actionIcon"
            [isDisabled]="actionDisabled"></sb-button>
          }
        </div>
      }
      <div class="summary__inner">
        <div class="summary__media hidden-xs">
          @if (eventDetails.from) {
            <sb-date [date]="eventDetails.from"></sb-date>
          }
          @if (!eventDetails.from) {
            <sb-icon class="loading-date" name="loading"></sb-icon>
          }
        </div>
        <div>
          <div class="align-center rhythm-m-b-h">
            <h1 [innerHTML]="eventDetails.title | translate"></h1>
            @if (eventDetails.additionalInfo) {
              <sb-icon
                name="info"
                class="ml-3 align-center pt-2"
                [ngbTooltip]="tooltipTemplate"
              tooltip-placement="right"></sb-icon>
            }
            <ng-template #tooltipTemplate>
              <span [innerHTML]="sanitizedAdditionalInfo"></span>
            </ng-template>
            @if (eventDetails.isCancelled) {
              <sb-badge
                [badgeClass]="'danger'"
                [message]="organisationLabelTags.Cancelled"
                class="ml-4">
              </sb-badge>
            }
            @if (eventDetails.eventType) {
              <sb-badge
                [badgeClass]="'neutral'"
                [message]="eventDetails.eventType"
                class="ml-4">
              </sb-badge>
            }
          </div>
          <div class="summary__info">
            @if (eventDetails.eventLocation?.name) {
              <div>
                @if (eventDetails.eventLocation?.name) {
                  <div>
                    <sb-icon name="location-pin" overrideStyle="light"></sb-icon><span [innerHTML]="eventDetails.eventLocation?.name"></span>
                  </div>
                }
              </div>
            }
            @if (eventDetails.owningEntityName || eventDetails.organiserName) {
              <div>
                @if (eventDetails.owningEntityName && eventDetails.eventType !== 'Transport') {
                  <div>
                    <sb-icon name="groups"></sb-icon> <span [innerHTML]="eventDetails.owningEntityName"></span>
                  </div>
                }
                @if (eventDetails.organiserName) {
                  <div>
                    <sb-icon name="users" override-style="solid"></sb-icon> <span [innerHTML]="eventDetails.organiserName"></span>
                  </div>
                }
              </div>
            }
            @if (timesLabel) {
              <div>
                <div>
                  <sb-icon name="clock" overrideStyle="light"></sb-icon>
                  <span [innerHTML]="timesLabel"></span>
                </div>
              </div>
            }
            <div ng-content></div>
          </div>
        </div>
      </div>
    </div>
  </header>
}
